import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled, View } from 'dripsy';

import { BaseText, LogoImage, Separator } from '@components';
import { IS_WEB } from '@utils';

const LogoContainer = styled(View)({
  alignItems: 'center',
});

const Title = styled(BaseText)({
  color: '$heading900',
  fontWeight: 'semi',
  textAlign: 'center',
  variant: IS_WEB ? 'text.xbig' : 'text.xxlarge',
});

export function SuggestedUsersListHeader() {
  const { t } = useTranslation();

  return (
    <Fragment>
      <LogoContainer>
        <LogoImage />
      </LogoContainer>

      <Separator size={['$8', '$5']} />
      <Title>{t('usersSuggestion.title')}</Title>
    </Fragment>
  );
}
